module.exports = __webpack_public_path__ + "static/media/04-Nürnberg@3x.3ec0435a.jpg";